export default __webpack_public_path__ + "static/media/no-image-found.1748fcf7.jpg";